import { render, staticRenderFns } from "./addCaigou.vue?vue&type=template&id=45f5764d&scoped=true&"
import script from "./addCaigou.vue?vue&type=script&lang=js&"
export * from "./addCaigou.vue?vue&type=script&lang=js&"
import style0 from "./addCaigou.vue?vue&type=style&index=0&id=45f5764d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5764d",
  null
  
)

export default component.exports